import mixpanel from 'mixpanel-browser';

import { RetainCancellationFlowShownResult } from '@paddle/paddle-js/types/checkout/retain';

export function mixPanelSubscriptionCancellationFlowCompleted(
    RetainCancellationFlowResult: RetainCancellationFlowShownResult
) {
    mixpanel?.track('mixpanel_cancellation_flow', RetainCancellationFlowResult);
}
